module.exports = {
  themes:[
    'initiativecoeur'
  ],
  components:[
    'modalFW',
    // 'block-editable',
    'block-list',
    'block-std',
    // 'block-img',
    // 'block-flip',
    'btn-load',
    // 'accordionFW',
    // 'headerFW',
    // 'heroFW',
    // 'sliderFW',
    'select2FW',
    // 'foldingbox',
    // 'tabs',
    // 'goto',
    // 'priceCard',
    // 'countUpFW',
    // 'ipsum',
    // 'input-number',
    'sidepanel',
    // 'guideline',
    // 'konami',
  ],
}


// WEBPACK FOOTER //
// ./framway.config.js